export default __webpack_public_path__ + "a5a07c37ee7f56502152f5dddd55541c.svg";